<template>
  <div>
    <div class="box">
      <div class="aside_header">
        <span >主管主页</span>
      </div>
      <div class="data_bankbox"  :style="{'background-image': `url(${info.userInfo.theme_img})`}">
        <div class="data_bankbox_childb">
          <div class="data_childb_a">
            <img :src="info.user_avatar" alt="" />
            <div class="data_childb_a_child">
              <div>
                <h2 style="padding-right: 10px">{{ info.alias_name }}</h2>
                <span v-if="info.is_real == 2">已认证</span>
                <span v-if="info.is_real == 1">未认证</span>
              </div>
              <div>{{ info.description }}</div>
            </div>
          </div>
          <div class="data_childb_b">
            <div class="data_childb_b_child">
              <div>
                <div>{{ info.popularity }}</div>
                <div>人气</div>
              </div>
              <div>
                <div>{{ info.credit }}</div>
                <div>信用</div>
              </div>
              <div>
                <div>{{ info.fans }}</div>
                <div>粉丝</div>
              </div>
              <div>
                <div>{{ info.focus }}</div>
                <div>关注</div>
              </div>
            </div>
            <div class="data_childb_b_childs">
              <div class="btn1" v-show="info.is_follow == 2 && info.is_user !=1" @click="attention">
                关注
              </div>
              <div class="btn1" v-show="info.is_follow == 1 && info.is_user  !=1" @click="cancel">
                已关注
              </div>
              <div class="btn2" v-show="info.is_user  !=1">去聊呗</div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="aside_box">
          <div class="divs">

            <div class="div_child">
              <div class="left">
                <div class="flag"></div>
                <div style="padding-left: 30px">自我评价</div>
              </div>
              <span class="right" @click="editInfo" >
                编辑
              </span>
            </div>

            <div class="div_childs" v-if="info.userInfo.introduce">
              {{ info.userInfo.introduce }}
            </div>

            <p  v-else style="text-align: center;">暂无评价</p>


            <div class="div_childs" style="margin-top: 20px">我的标签</div>
            <div class="div_childs" v-if="info.userInfo.labels&&info.userInfo.labels.length>0">
              <div class="flagsty" v-for="(item, index) in info.userInfo.labels" :key="index">
                {{ item }}
              </div>
            </div>
            <p  v-else style="text-align: center;">暂无标签</p>


            <div class="div_childs" style="margin-top: 40px">我的图片</div>
            <div class="div_childs" v-if="info.userInfo.images != null&&info.userInfo.images.length>0">
              <viewer v-for="(item, index) in info.userInfo.images" :key="index">
                <img :src="item" />
              </viewer>
            </div>
            <p  v-else style="text-align: center;">暂无图片</p>
          </div>
        </div>

        <div class="aside_box">
          <div class="divs">

            <div class="div_child">
              <div class="left">
                <div class="flag"></div>
                <div style="padding-left: 30px">创建的项目</div>
              </div>
              <span class="right" >
                查看更多
              </span>
            </div>



            <div class="div_childs" style="position: relative">
              <div class="data_box">
                <div class="data_child" style="height: 70px" v-for="(item, index) in info.project" :key="index">
                 
                  <div class="data_child_box_a">
                    <img :src="item.image" />
                    <div class="data_child_box_childas">
                      <div class="data_child_box_childas_box">
                        <div class="stys">
                          <span>{{ item.name }}</span>
                          <span>{{ item.description }}</span>
                        </div>
                        <div style="display: flex;align-items: center; width: 100px;">

                          <div class="dis_box" style="margin-right: 30px">
                            <span>{{ item.job_count }}</span>
                            <span>职位</span>
                          </div>
                          <div class="dis_box">
                            <span>{{ item.crowd_count }}</span>
                            <span>众包</span>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            
            </div>
          </div>
        </div>

        <div class="aside_box">
          <div class="divs">

            <div class="div_child">
              <div class="left">
                <div class="flag"></div>
                <div style="padding-left: 30px">我推荐的岗位</div>
              </div>
              <span class="right" >
                查看更多
              </span>
            </div>

            <div class="div_childs" style="position: relative">
              <div class="data_box">

                <div class="data_child" v-for="(item, index) in info.job" :key="index" @click="jobdetail(item.job_id)">
                  
                  <div class="data_child_box_a">
                    <img :src="item.logo" />
                    <div class="data_child_box_childa">
                      <div class="data_child_box_childa_boxa">
                        <span>{{ item.title }}</span>
                        <span style="font-size: 16px; color: red">{{ item.wages }}/{{ item.unit }}</span>
                      </div>
                      <div>
                        {{ item.education_str }}
                      </div>
                    </div>
                  </div>

                  <div class="data_child_box_c">{{ item.description }}</div>
                  <div class="data_child_box_b">
                    <div>截止日期：剩余{{ item.count_down }}</div>
                    <div>
                      空余岗位：<span style="color: red">{{
                        item.surplus_number
                      }}</span>个
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>

        <div class="aside_box">
          <div class="divs">

            <div class="div_child">
              <div class="left">
                <div class="flag"></div>
                <div style="padding-left: 30px">用户评价</div>
              </div>
              <span class="right" >
                查看更多
              </span>
            </div>

            <div class="div_childs" style="position: relative">
              <div class="data_box">
                <div class="data_child" style="height: 70px" v-for="(item, index) in info.assess" :key="index">
                  <div class="data_child_box_a">
                    <img :src="item.user_avatar" />
                    <div class="data_child_box_childas">
                      <div class="data_child_box_childas_box">
                        <div class="stys">
                          <div class="stys_child">
                            <span>{{ item.alias_name }}</span>
                            <span>{{ item.created_at }}</span>
                          </div>
                          <span><span>{{ item.content }}</span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </div>

        <div class="aside_box">
          <div class="divs">
     

            <div class="div_child">
              <div class="left">
                <div class="flag"></div>
                <div style="padding-left: 30px">主管人脉圈</div>
              </div>
              <span class="right" >
                查看更多
              </span>
            </div>


            <div class="div_childs">
              <div class="renmai">
                <div v-for="(item, index) in info.user" :key="index">
                  <div class="renmai_child">
                    <img :src="item.user_avatar" alt="" style="margin-right:0px" />
                    <span>{{ item.alias_name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <manager-edit-dialog ref="editRefDialog" @refresh="getinfo"></manager-edit-dialog>

  </div>
</template>

<script>

import { userdirectorinfo } from "@/api/director/talent/index";
import { followoption, followupdate } from "@/api/apply/index";
import managerEditDialog from "@/views/member/dialog/manager-edit-dialog.vue";


export default {
  components: {managerEditDialog},

  data () {
    return {
      id: "",
      info: {
        userInfo:{
          theme_img:"",
          images:[],
        }
      },
    };
  },
  created () {
    this.id = this.$route.query.id;
    this.getinfo();
  },
  mounted () { },
  methods: {
    jobdetail (id) {
      this.$router.push({ name: 'job-detail', query: { id: id } })
    },

    editInfo(){
      this.$refs.editRefDialog.init(this.info.userInfo);
    },
  
 
    //关注
    attention () {
      followoption({ user_app_id: this.info.user_app_id }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "已关注",
          });
          this.getinfo();
        } else {
          this.$message({
            type: "success",
            message: res.msg,
          });
        }
      });
    },
    //取关
    cancel () {
      let arr = [];
      arr.push(this.info.user_app_id);
      followupdate({ user_app_id: arr }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "取消关注",
          });
          this.getinfo();
        } else {
          this.$message({
            type: "success",
            message: res.msg,
          });
        }
      });
    },

    getinfo () {
      userdirectorinfo({ user_app_id: this.id, page: this.page }).then(
        (res) => {
          this.info = res.data;
        }
      );
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  width: 1200px;
  margin: auto;
  margin-bottom: 20px;
  .bottom_box {
    width: 100%;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 60px;
    margin-bottom: 30px;
  }
  .home_box {
    border: 1px solid #999999;
    opacity: 1;
    border-radius: 8px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    .home_childs {
      margin-left: 30px;
      padding: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
      margin-right: 40px;
      color: #4c71db;
      border-bottom: 1px solid #4c71db;
    }
    .home_child {
      margin-left: 30px;
      padding: 0 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 60px;
      margin-right: 40px;
    }
  }
  .aside_header {
    padding: 20px 0;
  }

  .aside_box {
    margin-top: 20px;

    .flag {
      width: 12px;
      height: 40px;
      background-color: #4c71db;
    }
    .divs {
      // width: 49%;
      border: 1px solid #b3b0b0;
      opacity: 1;
      border-radius: 8px;
      padding: 20px 0;
      .div_child {
        display: flex;
        align-items: center;
        .div_child_s {
          padding-left: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 90%;
        }
      }

      .div_child {
        display: flex;
        align-items: center;
        justify-content: space-between;
        img {
          width: 150px;
          height: 150px;
          border-radius: 15px;
          margin-right: 25px;
        }
        .left{
          display: flex;
          align-items: center;
        }
        .right{
          margin-right: 20px;
          color: #4c71db;
          cursor: pointer;

          a{
            margin-left: 20px;
            color: #4c71db;
            cursor: pointer;
          }
        }
      }


      .div_childs {
        padding: 10px 40px;
        display: flex;
        .renmai {
          display: flex;
          flex-wrap: wrap;
          .renmai_child {
            margin-right: 100px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img {
              width: 40px;
              height: 40px;
              border-radius: 8px;
            }
          }
        }
        .data_box {
          width: 100%;
          opacity: 1;
          border-radius: 8px;
          display: flex;
          flex-wrap: wrap;
          .data_child {
            padding: 20px;
            width: 44%;
            height: 120px;
            margin: 10px;
            border: 1px solid #ccc9cc;
            border-radius: 8px;
            .data_child_box_a {
              width: 100%;
              display: flex;
              align-items: center;
              .data_child_box_childas {
                width: 100%;
                padding-left: 20px;
                height: 60px;
                display: flex;
                align-items: center;
                .data_child_box_childas_box {
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  .stys {
                    width: 100%;
                    height: 60px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;
                    .stys_child {
                      width: 100%;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    }
                  }
                  .dis_box {
                    width: 40px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                  }
                }
              }
              .data_child_box_childa {
                width: 100%;
                padding-left: 20px;
                height: 60px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                .data_child_box_childa_boxa {
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                }
              }
              img {
                width: 60px;
                height: 60px;
                border-radius: 50%;
              }
            }
            .data_child_box_c {
              margin: 10px 0 10px 80px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .data_child_box_b {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
          }
        }
        .flagsty {
          padding: 5px 20px;
          background-color: #dedbde;
          margin-right: 20px;
        }
        img {
          width: 150px;
          height: 150px;
          border-radius: 15px;
          margin-right: 25px;
        }
        .bottom_box {
          width: 100%;
          position: absolute;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 60px;
          margin-bottom: 30px;
        }
      }
    }
  }
  .content_box {
    margin-top: 40px;
    display: flex;
    align-items: center;
    .content_box_child {
      margin-right: 150px;
      padding-bottom: 20px;
    }

    .content_box_childs {
      margin-right: 150px;
      color: #4f6fcd;
      border-bottom: 2px solid #4f6fcd;
      padding-bottom: 20px;
    }
  }
  .data_bankbox {
    border-radius: 8px;
    padding: 20px 20px 50px 20px;
    background-color: #cccccc;
    color: white;
    .data_bankbox_childa {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .data_bankbox_childb {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      .data_childb_a {
        display: flex;
        align-items: center;
        img {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
        .data_childb_a_child {
          height: 80px;
          display: flex;
          padding-left: 10px;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          div:nth-child(1) {
            display: flex;
            align-items: center;
            justify-content: center;
            span {
              font-size: 0.1rem;
              color: black;
              padding: 0 3px;
              background-color: white;
            }
          }
        }
      }
      .data_childb_b {
        width: 800px;
        height: 90px;
        display: flex;
        // flex-direction: column;
        justify-content: center;
        .data_childb_b_childs {
          display: flex;
          align-items: center;
          .btn1 {
            margin-left: 20px;
            margin-right: 20px;
            width: 100px;
            height: 35px;
            color: #4c71db;
            border: 1px solid #4c71db;
            border-radius: 30px;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }
          .btn2 {
            width: 100px;
            height: 35px;
            color: white;
            border-radius: 30px;
            background-color: #4c71db;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }
        }
        .data_childb_b_child {
          display: flex;
          div {
            margin: 0 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
